import React from 'react';
import { StatusInfoIcon } from '../../../_lib/components/StatusInfo/partials/StatusInfoIcon';
import { Icons } from '../../../components/atoms/SVG';
import { ContentParagraph } from '../../../_lib/components/ContentParagraph';
import { Strong } from '../../../components/atoms/Strong/Strong';
import { translatePartOfStringWithLink } from '../../../lib/StringUtils/StringHTMLUtils';
import { DateFormat, DateFormats } from '../../../_lib/components/DateFormat';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { PagePublicationInfoText } from '../../../_lib/components/PagePublicationInfo/partials/PagePublicationInfoText';
import { StatusInfoIconModifier } from '../../../_lib/components/StatusInfo/partials/StatusInfoIcon';

export function TimeControlledPublicationInfoText({ timeControlledPublication }: any) {
  const { t } = useSonTranslation('TimeControlledPublicationInfo');
  return (
    <PagePublicationInfoText>
      <StatusInfoIcon icon={Icons.ASSIGNMENT_PENDING} modifier={StatusInfoIconModifier.MARGIN_RIGHT} />
      <ContentParagraph>
        <Strong>{t('scheduledRelease')}</Strong>
        &nbsp;
        {timeControlledPublication.parentPageInfos
          ? translatePartOfStringWithLink(
              'TimeControlledPublicationInfo:forParentPage',
              timeControlledPublication.parentPageInfos.url,
              true,
              { nameParentPage: timeControlledPublication.parentPageInfos.name }
            )
          : t('for')}
        &nbsp;
        <Strong>
          {t('at')}
          &nbsp;
          <DateFormat date={timeControlledPublication.scheduledDate} format={DateFormats.DATE_TIME} />
        </Strong>
      </ContentParagraph>
    </PagePublicationInfoText>
  );
}
